import {
    SMS_SYSTEM_DELETE_OPEN_MODAL,
    SMS_SYSTEM_DELETE_REQUEST,
    SMS_SYSTEM_DELETE_RESULT
} from 'Redux/actionTypes';

export const smsSystemDeleteOpenModal = (open, data) => ({
    type: SMS_SYSTEM_DELETE_OPEN_MODAL,
    payload: { open, data }
})
export const smsSystemDeleteRequest = (data) => ({
    type: SMS_SYSTEM_DELETE_REQUEST,
    payload: data
})
export const smsSystemDeleteResult = (data) => ({
    type: SMS_SYSTEM_DELETE_RESULT,
    payload: data
})

